<div
  class="buttons"
  [ngClass]="{ 'scroll-bottom': scrollStyle }"
  [hidden]="unfFlowSvc.getloading()"
>
  @if (currentStep === 0 || currentStep === '0') {
    <span class="back-button-placeholder"></span>
  } @else {
    <button
      mat-button
      class="btn nav-btn-primary"
      type="button"
      [disabled]="navDisabled || unfFlowSvc.getSaving()"
      (click)="handleTabChange('back')"
    >
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  }

  @if (navDisabled || unfFlowSvc.getSaving()) {
    <span class="saving-indicator">
      <span>Save in Progress</span>
      <mat-progress-bar mode="indeterminate" color="accent" />
    </span>
  }

  @if (currentApp !== 'summary') {
    @if (
      (currentStep !== 'results' &&
        currentStep !== 'validate' &&
        currentStep !== 'products') ||
      ((currentStep === 'results' || currentStep === 'validate') &&
        modStatusSvc.showCaseSummary()) ||
      (currentApp === 'li' &&
        currentStep === 'results' &&
        !modStatusSvc.showCaseSummary()) ||
      (currentApp === 'li' &&
        currentStep === 'products' &&
        modStatusSvc.showCaseSummary())
    ) {
      <button
        mat-button
        class="btn nav-btn-primary next-button"
        type="button"
        [disabled]="navDisabled || unfFlowSvc.getSaving()"
        (click)="handleTabChange('next')"
      >
        Next <mat-icon>arrow_forward</mat-icon>
      </button>
    }
  }
</div>
